module.exports = __webpack_public_path__ + "static/media/logo-netsuite.477070c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-netsuite.png
// module id = 1304
// module chunks = 17